<template>

  <div>
    <treeselect
      :value="value"
      @input="$emit('input', $event)"
      :normalizer="normalizer"
      :options="options"
      :multiple="true"
      :limit="1"
      :placeholder="$t('map.filters.asset-type')"
      :clearAllText="$t('clear')"
      :limitText="(n) => $t('and-more', [n])"
      :flat="true"
      :appendToBody="true"
      :autoSelectDescendants="true"
      :autoDeselectDescendants="true"
      auto-focus
    />
  </div>

</template>

<script>

export default {
  name: 'asset-types-tree',

  props: [ 'value' ],

  data () {
    return {
      tree: {},
      options: []
    }
  },

  methods: {
    normalizer ({ id, name, children }) {
      return {
        id,
        label: name,
        children: children && children.length ? children : undefined
      }
    },
  },

  async created () {
    await this.$store.dispatch('getStaticItems', { model: { name: 'asset-types', tree: true } })

    this.tree = this.$store.state.staticItems['asset-types']
    this.options = this.tree.roots()
  },
}

</script>

<style lang="scss">

  .vue-treeselect--append-to-body {
    font-family: 'Roboto', sans-serif;
    line-height: 1.5;
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.87);

    .vue-treeselect__option {
      margin-top: 3px;
    }
  }

</style>
